import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './GroupAdminPage.css'; 
import '../index.css'

const AdminGroupPage = () => {
    const { groupId } = useParams();  // Fetch the groupId from the URL
    const [groupDetails, setGroupDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Fetch the admin group details
    useEffect(() => {
        const fetchAdminGroupDetails = async () => {
            try {
                const response = await axios.get(`https://wholeness-forward.onrender.com/api/group/${groupId}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });

                setGroupDetails(response.data);
                setLoading(false);
            } catch (err) {
                setError('Error fetching admin group details');
                setLoading(false);
            }
        };

        fetchAdminGroupDetails();
    }, [groupId]);
    
   
    
    // Copy Join Code to Clipboard
    const copyJoinCode = () => {
        if (groupDetails?.joinCode) {
            navigator.clipboard.writeText(groupDetails.joinCode);
            alert("Join Code copied to clipboard!");
        }
    };
   
    // Delete member from the group
    // const handleDeleteMember = async (userId) => {
    //     try {
    //         // Make sure userId is a string
    //         const userIdString = userId?.toString() || ''; // Ensure it's a string, fall back to an empty string if undefined
            
    //         if (!userIdString) {
    //             alert('Invalid userId');
    //             return;
    //         }
    
    //         const response = await axios.delete(`https://wholeness-forward.onrender.com/api/group/${groupId}/member/${userId}`, {
    //             headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    //         });
    
    //         alert(response.data.message);
    
    //         setGroupDetails(prevState => ({
    //             ...prevState,
    //             members: prevState.members.filter(member => member.userId !== userIdString)
    //         }));
    
    //     } catch (err) {
    //         setError('Error deleting member');
    //     }
    // };

    if (loading) return <p className="loading">🔄 Loading...</p>;
    if (error) return <p className="error">{error}</p>;

    return (
        <div className="group-page-container">
            <h1 className="toc-title">Admin Page for {groupDetails.name}</h1>
            <h3 className="admin-name">Admin: {groupDetails.adminName}</h3>

            <div className="join-code-section">
            <h3 className="admin-name">{groupDetails.name}</h3>
                <p><strong>Members</strong> ({groupDetails.members.length}/{groupDetails.maxMembers})</p>
                {groupDetails.members.length > 0 ? (
                    <ul className="member-list">
                        {groupDetails.members.map((member) => (
                            <li key={member.userId?._id ?? member.name}> {member.name}</li>
                        ))}
                    </ul>
                ) : (
                    <p>❌ No members yet.</p>
                )}
            </div>

            {/* Display Group Join Code and Copy Button */}
            <div className="join-code-section">
                <p><strong>Join Code:</strong> <span className="join-code">{groupDetails.joinCode}</span></p>
                <button className="forum-button" onClick={copyJoinCode}>Copy Code</button>
            </div>
                <div className="mini-void"></div>

            {/* Displaying Members
            <p className="members-header">Members:</p>
            {groupDetails.members && groupDetails.members.length > 0 ? (
                <ul className="member-list">
                    {groupDetails.members.map((member) => (
                        <li key={member.userId} className="member-item">
                            {member.name} - Start Weight: {member.startingWeight} lbs | Latest Weight: {member.latestWeightG} lbs | Weight Lost: {member.weightLost} lbs
                            <button className="delete-button" onClick={() => handleDeleteMember(member.userId)}>Delete Member</button>
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No members in this group yet.</p>
            )} */}
            <div className="weight-loss-summary">
                <p><strong>Group Created:</strong> <span className="join-code">{new Date(groupDetails.createdAt).toLocaleDateString()}</span></p>
                <p><strong>Total Weight Lost:</strong> <span className="join-code">{(groupDetails.totalWeightLostG / 453.592).toFixed(1)} lbs</span></p>
                {/* <p>Weekly Weight Lost: {(groupDetails.weeklyWeightLostG / 453.592).toFixed(1)} lbs</p>
                <p>Monthly Weight Lost: {(groupDetails.monthlyWeightLostG / 453.592).toFixed(1)} lbs</p>
                <p>Yearly Weight Lost: {(groupDetails.yearlyWeightLostG / 453.592).toFixed(1)} lbs</p> */}
            </div>

        </div>
    );
};

export default AdminGroupPage;
